import { useSwingAnalysis, useSwingVideos } from '@queries';

// Temporary solution to sync atoms
export const useIsSwingDataLoading = (swingId: string) => {
    const swingAnalysis = useSwingAnalysis(swingId);
    const swingVideos = useSwingVideos(swingId);

    return { swingAnalysis, swingVideos };
};
